import axios from "axios";
import React, { createContext, useState, useContext } from "react";
import { getAuth } from "../../app/modules/auth";
import { showErrorMessage } from "./MessagesHelper";
import { getIn } from "formik";

type StyleType = {
  _id: number;
  type: string;
  primary_color: string;
  secondary_color: string;
  primary_text_color: string;
  secondary_text_color: string;
  sidebar_background_color: string;
  sidebar_text_color: string;
  header_background_color: string;
  header_text_color: string;
  footer_background_color: string;
  footer_text_color: string;
  toolbar_background_color: string;
  toolbar_text_color: string;
};

type PropsStyleContext = {
  styleState: StyleType;
  updateStyle: (newStyle: Partial<StyleType>) => void;
  loadStyleContext: () => void;
  getStyleColors: () => Promise<StyleType>;
};

const DEFAULT_STYLE: StyleType = {
  _id: 0,
  type: "",
  primary_color: "",
  secondary_color: "",
  primary_text_color: "",
  secondary_text_color: "",
  sidebar_background_color: "",
  sidebar_text_color: "",
  header_background_color: "",
  header_text_color: "",
  footer_background_color: "",
  footer_text_color: "",
  toolbar_background_color: "",
  toolbar_text_color: "",
};

const getStyleColors = async () => {
  const apiToken = getAuth();
  const token = apiToken?.api_token;
  const apiUrl = process.env.REACT_APP_API_URL;
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  if (apiToken) {
    try {
      const response = await axios.get(`${apiUrl}/template-colors/companies`, {
        headers,
      });
      response.data.type = getIn(response.data.type, "description");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
};

const StyleContext = createContext<PropsStyleContext>({
  styleState: DEFAULT_STYLE,
  updateStyle: () => {},
  loadStyleContext: () => {},
  getStyleColors: getStyleColors,
});

export const useStyleContext = () => useContext(StyleContext);

interface StyleProviderProps {
  children: React.ReactNode;
}

const StyleProvider: React.FC<StyleProviderProps> = ({ children }) => {
  const [styleState, setStyleState] = useState<StyleType>(DEFAULT_STYLE);

  const updateStyle = (newStyle: Partial<StyleType>) => {
    setStyleState((prevStyle) => ({
      ...prevStyle,
      ...newStyle,
    }));
  };
  const apiToken = getAuth();
  const token = apiToken?.api_token;
  const apiUrl = process.env.REACT_APP_API_URL;

  const loadStyleContext = () => {
    if (apiToken) {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .get(`${apiUrl}/template-colors/companies`, {
          headers,
        })
        .then((response) => {
          const data = response?.data;
          data.type = getIn(data.type, "description");
          updateStyle(data);
        })
        .catch((error) => {
          showErrorMessage(
            error?.response?.data?.error?.statusCode,
            error?.response?.data?.error?.message
          );
        });
    }
  };

  return (
    <StyleContext.Provider
      value={{ styleState, updateStyle, loadStyleContext, getStyleColors }}
    >
      {children}
    </StyleContext.Provider>
  );
};

export { StyleProvider, StyleContext };
